import { render, staticRenderFns } from "./TxPresenterSettings.vue?vue&type=template&id=54515350&scoped=true"
import script from "./TxPresenterSettings.vue?vue&type=script&lang=js"
export * from "./TxPresenterSettings.vue?vue&type=script&lang=js"
import style0 from "./TxPresenterSettings.vue?vue&type=style&index=0&id=54515350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54515350",
  null
  
)

export default component.exports